import { contactCard } from '../../../shared';

export const sellersAgentCard = contactCard(
  'sellerSideContacts.sellersAgent',
  'counterpartyAgent',
);
